import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(() => {
  return {
    header: { cursor: "pointer" },
    collapsible: {
      transition: "transform .4s ease-in-out"
    },
    opened: {
      transform: "rotate(180deg)"
    },
    closed: {
      transform: "rotate(0deg)"
    }
  };
});
